/*
* 正则表达式和验证公用的方法
* REG 为正则表达式定义
* PUBLIC 为公共使用的验证方法
* PRIVATE 为私有的验证方法
* */
// 小数及整数等所有数字正则 四位小数
export const REG_ALL_NUMBER = /^0{1}([.]\d{1,4})?$|^[1-9]\d*([.]{1}[0-9]{1,4})?$/
export const REG_ALL_NUMBER2 = /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/
export const REG_ALL_NUMBER3 = /^0{1}([.]\d{1,3})?$|^[1-9]\d*([.]{1}[0-9]{1,3})?$/

// 正整数
export const REG_NUMBER = /^[0-9]*[1-9][0-9]*$/
// 大写字母正则,一般用于代码验证
export const REG_UPPER_WORD = /[A-Z]+$/
// 英文正则
export const REG_LETTER = /[A-Za-z]+$/
// 手机号正则,只验证手机号码为11位，且以1开头
export const REG_PHONE = /^1[0-9]{10}$/
// 手机号可以为空
export const REG_PHONE_NULL = /^$|^1[0-9]{10}$/
// 身份证
export const REG_ID_NUMBER = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
// 邮箱
export const REG_EMAIL = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
// 中文
export const REG_CHINESE = /^[\u4e00-\u9fa5]+$/
// 中文,英文,数字
export const REG_TEXT = /^[A-Za-z0-9\u4e00-\u9fa5]+$/
export const REG_TEXT2 = /^[A-Za-z0-9,\u4e00-\u9fa5]{1,32}$/
// 字母,数字
export const REG_NUM_CODE = /^[0-9a-zA-Z]+$/
export const REG_NUM_CODE2 = /^[0-9]+$/
export const REG_NUM_CODE3 = /^[0-9a-zA-Z_]{1,32}$/
// 一个大写字母和2位数字
export const REG_NUM_CAP = /^[A-Z][0-9]{2}$/
// 大写字母和中文
export const REG_CAP_NUM = /^[A-Z0-9]+$/
// 银行卡
export const REG_BANK_CARD = /^([1-9]{1})(\d{14}|\d{18})$/
// 0-100的整数(保证金比例)
export const REG_ZERO_HUNDRED = /^(0|[1-9][0-9]?|100)$/
// 字母,数字,小数点
export const REG_LETTER_NUM_POINT = /^[0-9a-zA-Z\.]+$/
// 数字,两位小数点
export const REG_NUM_POINT_TWO = /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/
// 车牌号校验
export const REG_CAR_NUM = /^[A-Z0-9\u4e00-\u9fa5]+$/;  
// 英文、数字、下划线 32位字符
export const REG_USER_NAME = /^[0-9a-zA-Z_]{1,32}$/;  

// 公共验证方法
// 根据需求,限制'非法字符'
export const REG_LIMIT = /[@#\$%\^&\*]+/
const LIMIT = ['!', '@', '#', '$', '%', '^', '&']
export const PUBLIC_LIMIT = (r, v, c) => {
    if (!v) {
        return c(new Error('此文本框不能为空'))
    } else {
        if (!REG_LIMIT.test(v)) {
            c()
        } else {
            return c(new Error('只能输入中文,字母及数字'))
        }
    }

}

export const PUBLIC_NUM_CODE = (r, v, c) => {
    if (REG_NUM_CODE.test(v)) {
        c()
    } else if (v === '' || v === undefined || v === null){
        return c(new Error('此文本不能为空'))
    }else {
        return c(new Error('只能输入数字或字母'))
    }
}

// 一个大写字母和2位数字
export const PUBLIC_NUM_CAP = (r, v, c) => {
    if (REG_NUM_CAP.test(v)) {
        c()
    } else {
        return c(new Error('请输入一个大写字母和2位数字'))
    }
}

// 大写字母和数字
export const PUBLIC_CAP_NUM = (r, v, c) => {
    if (REG_CAP_NUM.test(v)) {
        c()
    } else {
        return c(new Error('只能输入大写字母及数字'))
    }
}

// 小数整数相关验证
export const PUBLIC_NUMBER = (r, v, c) => {
    if (REG_ALL_NUMBER.test(v)) {
        c()
    } else {
        return c(new Error('请输入正确的数字'))
    }
}
export const PUBLIC_INT_NULL = (r, v, c) => {
    if (REG_NUMBER.test(v) || v === '' || v === undefined || v === null) {
        c()
    } else {
        return c(new Error('请输入正确的数字'))
    }
}
export const PUBLIC_INT_NULL_ZERO = (r, v, c) => {
    if (v==='0'||v===0||REG_NUMBER.test(v) || v === '' || v === undefined || v === null) {
        c()
    } else {
        return c(new Error('请输入正确的数字'))
    }
}
export const PUBLIC_INT_NULL_ZZZ = (r, v, c) => {
    if (REG_NUMBER.test(v) || v === '' || v === undefined || v === null) {
        c()
    } else {
        return c(new Error('请输入正整数'))
    }
}
// 数字可以为空,及验证时为非必填
export const PUBLIC_NUMBER_NULL = (r, v, c) => {
    if (v === null || v === undefined || v === '' || REG_ALL_NUMBER.test(v)) {
        c()
    } else {
        return c(new Error('请输入正确的数字'))
    }
}

export const PUBLIC_NUMBER_NULL2 = (r, v, c) => {
    if (v === null || v === undefined || v === '' || REG_ALL_NUMBER2.test(v)) {
        c()
    } else {
        return c(new Error('请输入正确的数字且最多输入2位小数'))
    }
}

export const PUBLIC_NUMBER_NULL3 = (r, v, c) => {
    if (v === null || v === undefined || v === '' || REG_ALL_NUMBER3.test(v)) {
        c()
    } else {
        return c(new Error('请输入正确的数字且最多输入3位小数'))
    }
}

//0-100的整数
export const PUBLIC_DEPOSIT_RATIO = (r, v, c) => {
    if (v === undefined || v === '' || REG_ZERO_HUNDRED.test(v)) {
        c()
    } else {
        return c(new Error('请输入0-100的数值'))
    }
}

// 电话验证 正整数即可
export const PUBLIC_TEL = (r, v, c) => {
    if (v === undefined || v === '' || v === null || REG_NUMBER.test(v)) {
        c()
    } else {
        return c(new Error('请输入正确的电话号码'))
    }
}

// 手机号验证
export const PUBLIC_PHONE = (r, v, c) => {
    if (REG_PHONE.test(v)) {
        c()
    } else {
        return c(new Error('请输入正确的手机号'))
    }
}

// 手机号验证New
export const PUBLIC_PHONE_NEW = (r, v, c) => {
    if(v!=''){
        if(v===null){
            c()
        }else{
            if (REG_PHONE.test(v)) {
                c()
            } else {
                return c(new Error('请输入正确的手机号'))
            }
        }
    }else{
        c()
    }
}

// 手机号验证 可以为空
export const PUBLIC_PHONE_NULL = (r, v, c) => {
    if (v === undefined || REG_PHONE_NULL.test(v)) {
        c()
    } else {
        return c(new Error('请输入正确的手机号'))
    }
}

// 身份证验证
export const PUBLIC_ID_NUMBER = (r, v, c) => {
    if (REG_ID_NUMBER.test(v)) {
        c()
    } else {
        return c(new Error('请输入正确的身份证号码'))
    }
}
export const PUBLIC_NOT_ID_NUMBER = (r, v, c) => {
    if (v === undefined || v === '' || v === null || REG_ID_NUMBER.test(v)) {
        c()
    } else {
        return c(new Error('请输入正确的身份证号码'))
    }
}

// 邮箱验证
export const PUBLIC_EMAIL = (r, v, c) => {
    if (v === undefined || v === '' || REG_EMAIL.test(v)) {
        c()
    } else {
        return c(new Error('请输入正确的邮箱'))
    }
}

// 中文
export const PUBLIC_CHINESE = (r, v, c) => {
    if (REG_CHINESE.test(v)) {
        c()
    } else {
        return c(new Error('请输入正确的中文'))
    }
}

// 非中文1
export const PUBLIC_NOT_CHINESE = (r, v, c) => {
    if (!REG_CHINESE.test(v)) {
        c()
    } else {
        return c(new Error('不能输入中文'))
    }
}
// 非中文2
export const PUBLIC_NOT_CHINESE_TWO = (r, v, c) => {
    if(v===undefined||v===''||v===null){
        return c(new Error('请输入字母或数字'))
    }
    if (!REG_CHINESE.test(v)) {
        c()
    } else {
        return c(new Error('请输入字母或数字'))
    }
}

// 私有验证方法
// 验证代码相关
export const PRIVATE_CODE = (r, v, c) => {
    if (!v) {
        return c(new Error('请输入代码'))
    } else {
        if (REG_UPPER_WORD.test(v)) {
            c()
        } else {
            return c(new Error('代码均为大写字母'))
        }
    }
}

// 验证客户单位
export const PRIVATE_CUSTOMER_UNIT = (r, v, c) => {
    if (v === undefined) {
        return c(new Error('请选择客户单位'))
    } else {
        c()
    }
}

export const PRIVATE_BAY = (r, v, c) => {
    if (!v) {
        return c(new Error('请输入最大贝位号'))
    } else {
        if (REG_NUMBER.test(v) && v % 2 !== 0) {
            c()
        } else {
            return c(new Error('请输入奇数贝位'))
        }
    }
}

export const PRIVATE_LINE = (r, v, c) => {
    if (!v) {
        return c(new Error('请输入专运线'))
    } else if (REG_NUM_CODE.test(v)) {
        c()
    } else {
        return c(new Error('只能输入数字或字母'))
    }
}

export const PRIVATE_AREA = (r, v, c) => {
    if (!v) {
        return c(new Error('请输入场区'))
    } else if (REG_NUM_CODE.test(v)) {
        c()
    } else {
        return c(new Error('只能输入数字或字母'))
    }
}

// 金额校验（两位小数）
export const PRIVATE_POINT_TWO = (r, v, c) => {
    if (REG_NUM_POINT_TWO.test(v)) {
        c()
    } else {
        return c(new Error('只能输入数字且保留两位小数'))
    }
}
//车牌号校验
export const PRIVATE_CAR_NUM = (r, v, c) => {
    if (v === undefined || v === '' || v === null || REG_CAR_NUM.test(v)) {
        c()
    } else {
        return c(new Error('车牌号输入不合法'))
    }
}
//付款人
export const PUBLIC_PEOPLE_NUM = (r, v, c) => {
    if (REG_TEXT.test(v)) {
        c()
    } else {
        return c(new Error('只能输入中文、英文、数字'))
    }
}
// 提单号
export const PUBLIC_NUM_NO = (r, v, c) => {
    if (v === undefined || v === '' || v === null || REG_NUM_CODE.test(v)) {
        c()
    }else {
        return c(new Error('只能输入数字或字母'))
    }
}


//数字
export const PUBLIC_REG_NUM_CODE2 = (r, v, c) => {
    if (REG_NUM_CODE2.test(v)) {
        c()
    } else {
        return c(new Error('只能输入数字'))
    }
}

//车牌号校验
export const PRIVATE_ZSX = (r, v, c) => {
    if (v === undefined || v === '' || v === null || REG_NUM_CODE3.test(v)) {
        c()
    } else {
        return c(new Error('只能输入字母，数字，下划线'))
    }
}























































// WEBPACK FOOTER //
// ./src/utils/Reg.js